<ng-container *ngIf="loaded">
  <tidy-row [align]="'center'" *ngIf="filteredNotifications.length === 0">
    <tidy-text
      [body]="'<i>No notifications yet</i>'">
    </tidy-text>
  </tidy-row>

  <tidy-row [align]="'center'" *ngIf="showExamples">
    <tidy-text
      *ngIf="!showKeys"
      [body]="'Show Keys'"
      (action)="onToggleKeys()">
    </tidy-text>
    <tidy-text
      *ngIf="showKeys"
      [body]="'Hide Keys'"
      (action)="onToggleKeys()">
    </tidy-text>
  </tidy-row>

  <ng-container *ngIf="showExamples">
    <ng-container *ngFor="let notification of examples">
      <tidy-card>
        <tidy-row style="margin-bottom: 5px">
          <tidy-text
            [body]="notification?.created_at | formatDateTimePipe:'MMM d h:mma'"
            style="color: var(--tidy-text-muted, #e0e0e0); font-size: 12px;">
          </tidy-text>
        </tidy-row>
        <tidy-row class="vertical-align-middle">
          <tidy-image
            [src]="notification?.icon"
            class="header-size"
            style="margin-right: 8px; min-width: 20px; flex-shrink: 0;">
          </tidy-image>
          <tidy-text [body]="'<b>' + notification?.email_template_subject + '</b>'"></tidy-text>
        </tidy-row>
        <tidy-row class="extra-top-padding" *ngIf="showKeys">
          <tidy-text [body]="notification?.notification_key"></tidy-text>
        </tidy-row>
      </tidy-card>
    </ng-container>
  </ng-container>

  <ng-container *ngFor="let notification of filteredNotifications">
    <tidy-row>
      <tidy-card *ngIf="notification?.title">
        <tidy-card-button (action)="onNotificationClick(notification)" [hideArrow]="!hasNotificationAction(notification)" [style.cursor]="notification?.is_read ? null : 'pointer'">
          <tidy-row style="margin-bottom: 5px">
            <tidy-text
              [body]="notification?.created_at | formatDateTimePipe:'MMM d h:mma'"
              style="color: var(--tidy-text-muted, #e0e0e0); font-size: 12px;">
            </tidy-text>
          </tidy-row>
          <div style="display: flex; align-items: flex-start; gap: 5px;">
            <tidy-image
              [src]="notification?.icon"
              class="header-size"
              style="min-width: 20px; flex-shrink: 0;">
            </tidy-image>
            <div style="flex: 1;">
              <tidy-markdown
                *ngIf="!notification?.is_read"
                [allBold]="true"
                [markdownContent]="parseNotificationTitle(notification?.title) + (notification?.groupedMessagesArray?.length > 0 ? ' (+' + notification?.groupedMessagesArray?.length  + ' more)' : '')">
              </tidy-markdown>
              <tidy-markdown
                *ngIf="notification?.is_read"
                [markdownContent]="parseNotificationTitle(notification?.title) + (notification?.groupedMessagesArray?.length > 0 ? ' (+' + notification?.groupedMessagesArray?.length  + ' more)' : '')">
              </tidy-markdown>
            </div>
          </div>
          <tidy-row class="extra-top-padding" *ngIf="showKeys">
            <tidy-text [body]="notification?.notification_key"></tidy-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    </tidy-row>
  </ng-container>

  <ion-infinite-scroll (ionInfinite)="onLoadMore($event)" *ngIf="filteredNotifications.length < totalNotifications">
    <ion-infinite-scroll-content
      loadingSpinner="bubbles"
      loadingText="Loading more notifications...">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ng-container>

<ng-container *ngIf="!loaded">
  <ng-container *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
    <tidy-card>
      <div style="display: flex; align-items: center; margin-bottom: 5px">
        <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px"></ion-skeleton-text>
        <ion-skeleton-text animated="true" style="width: 89%; height: 16px; border-radius: 6px;"></ion-skeleton-text>
      </div>
    </tidy-card>
    <tidy-card>
      <div style="display: flex; align-items: center; margin-bottom: 5px">
        <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px"></ion-skeleton-text>
        <ion-skeleton-text animated="true" style="width: 70%; height: 16px; border-radius: 6px;"></ion-skeleton-text>
      </div>
    </tidy-card>
    <tidy-card>
      <div style="display: flex; align-items: center; margin-bottom: 5px">
        <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px"></ion-skeleton-text>
        <ion-skeleton-text animated="true" style="width: 100%; height: 16px; border-radius: 6px;"></ion-skeleton-text>
      </div>
      <div style="display: flex; align-items: center;">
        <ion-skeleton-text animated="true" style="width: 34%; height: 16px; border-radius: 6px;"></ion-skeleton-text>
      </div>
    </tidy-card>
    <tidy-card>
      <div style="display: flex; align-items: center; margin-bottom: 5px">
        <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px"></ion-skeleton-text>
        <ion-skeleton-text animated="true" style="width: 83%; height: 16px; border-radius: 6px;"></ion-skeleton-text>
      </div>
    </tidy-card>
    <tidy-card>
      <div style="display: flex; align-items: center; margin-bottom: 5px">
        <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px"></ion-skeleton-text>
        <ion-skeleton-text animated="true" style="width: 100%; height: 16px; border-radius: 6px;"></ion-skeleton-text>
      </div>
      <div style="display: flex; align-items: center;">
        <ion-skeleton-text animated="true" style="width: 58%; height: 16px; border-radius: 6px;"></ion-skeleton-text>
      </div>
    </tidy-card>
    <tidy-card>
      <div style="display: flex; align-items: center; margin-bottom: 5px">
        <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px"></ion-skeleton-text>
        <ion-skeleton-text animated="true" style="width: 63%; height: 16px; border-radius: 6px;"></ion-skeleton-text>
      </div>
    </tidy-card>
    <tidy-card>
      <div style="display: flex; align-items: center; margin-bottom: 5px">
        <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px"></ion-skeleton-text>
        <ion-skeleton-text animated="true" style="width: 93%; height: 16px; border-radius: 6px;"></ion-skeleton-text>
      </div>
    </tidy-card>
    <tidy-card>
      <div style="display: flex; align-items: center; margin-bottom: 5px">
        <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px"></ion-skeleton-text>
        <ion-skeleton-text animated="true" style="width: 56%; height: 16px; border-radius: 6px;"></ion-skeleton-text>
      </div>
    </tidy-card>
    <tidy-card>
      <div style="display: flex; align-items: center; margin-bottom: 5px">
        <ion-skeleton-text animated="true" style="width: 20px; height: 20px; border-radius: 6px; margin-right: 5px"></ion-skeleton-text>
        <ion-skeleton-text animated="true" style="width: 68%; height: 16px; border-radius: 6px;"></ion-skeleton-text>
      </div>
    </tidy-card>
  </ng-container>
</ng-container>
